/**
 * API配置文件
 * 集中管理API的基本URL和请求路径
 */

// 声明全局window.CONFIG类型
declare global {
	interface Window {
		CONFIG?: {
			API_BASE_URL?: string;
			[key: string]: any;
		};
	}
}

// API基础URL - 优先从window.CONFIG获取，其次是环境变量，最后是默认值
export const API_BASE_URL = (() => {
	// 优先使用window.CONFIG中的API_BASE_URL
	if (window.CONFIG?.API_BASE_URL) {
		return window.CONFIG.API_BASE_URL;
	}
	// 默认值
	return "ps-assistant-gateway-api";
})();

// API端点
export const API_ENDPOINTS = {
	// 新会话接口
	NEW_SESSION: `${API_BASE_URL}/new_session`,

	// 聊天接口
	CHAT: `${API_BASE_URL}/chat2`,

	// 获取图片base64接口
	GET_IMAGE_BASE64: `${API_BASE_URL}/get_image_base64`,

	// 提交用户信息接口
	SUBMIT: `${API_BASE_URL}/save_user_info`,
};

// 从 localStorage 获取会话 ID
export const getSessionIdFromStorage = (): string => {
	return localStorage.getItem("session_id") || "";
};

// 保存会话 ID 到 localStorage
export const saveSessionIdToStorage = (sessionId: string): void => {
	localStorage.setItem("session_id", sessionId);
};

// 清除 localStorage 中的会话 ID
export const clearSessionIdFromStorage = (): void => {
	localStorage.removeItem("session_id");
};

/**
 * 封装通用的API请求函数
 */
export const apiRequest = async (
	endpoint: string,
	options: RequestInit = {}
) => {
	try {
		// 获取当前会话ID
		const sessionId = getSessionIdFromStorage();

		// 创建请求配置
		const requestOptions: RequestInit = {
			...options,
			headers: {
				"Content-Type": "application/json",
				// 添加CORS相关头信息
				"X-Requested-With": "XMLHttpRequest",
				"Access-Control-Allow-Origin": "*",
				"Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
				"Access-Control-Allow-Headers":
					"Content-Type, Authorization, X-Requested-With",

				// 将会话ID添加到请求头
				...(sessionId ? { session_id: sessionId } : {}),

				...options.headers,
			},
			// 添加 credentials 以发送 cookies，如果需要
			// credentials: "include",
			// 跨域请求配置
			mode: "cors",
			cache: "no-cache",
		};

		// 如果是聊天接口，且请求体中没有包含session_id，则添加到请求体中
		if (
			endpoint.includes("/chat") &&
			options.method === "POST" &&
			options.body
		) {
			try {
				const bodyObj = JSON.parse(options.body as string);
				if (!bodyObj.session_id && sessionId) {
					bodyObj.session_id = sessionId;
					requestOptions.body = JSON.stringify(bodyObj);
				}
			} catch (e) {
				console.error("解析请求体失败:", e);
			}
		}

		// 使用完整的URL进行请求
		const response = await fetch(endpoint, requestOptions);

		if (!response.ok) {
			throw new Error(`API错误: ${response.status} ${response.statusText}`);
		}

		return await response.json();
	} catch (error) {
		console.error("API请求错误:", error);
		throw error;
	}
};
